

import Dashboard from "layouts/dashboard";
import ChargerMgmt from "layouts/charger_mgmt";
import LocationMgmt from "layouts/location_mgmt";
import Notifications from "layouts/notifications";
import CustomerService from "layouts/customer_service";
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import HistoryIcon from '@mui/icons-material/History';
import Log from "layouts/log-mgmt";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Admin from "layouts/Admins/Admins";
import SignIn from "layouts/SignIn/SignIn";
import Icon from "@mui/material/Icon";
import HomeIcon from '@mui/icons-material/Home';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ViewCharger from "layouts/charger_mgmt/ViewCharger";
import ViewLocation from "layouts/location_mgmt/ViewLocation";
import Reports from "layouts/reports";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import PowerIcon from '@mui/icons-material/Power';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import UpdateLocation from "layouts/location_mgmt/UpdateLocation";
import ViewTransaction from "layouts/charger_mgmt/ViewTransaction";
import DriverMgmt from "layouts/Driver_management";
import UpdateDriverPassword from "layouts/Driver_management/UpdateDriverPassword";
import Reservation from "layouts/Reservation";
import UpdateDriver from "layouts/Driver_management/UpdateDriver";
import VehicleMgmt from "layouts/Vehicle_mgmt";
import UpdateVehicle from "layouts/Vehicle_mgmt/UpdateVehicle";
import AssignDriver from "layouts/Driver_management/AssignDriver";
import Driver_Mgmt_url from "./assets/cms-icons/driverMgmt.png";
import Vehicle_mgmt_url from "./assets/cms-icons/image (1).png";
import VendorPerformanceUrl from "./assets/cms-icons/vender_performance.png"
import ViewDriver from "layouts/Driver_management/ViewDriver";
import { getDecodedUserData } from "utils/Constant";
import SystemManagement from "layouts/SystemManagement";
import NotificationsPage from "layouts/SystemManagement/NotificationsPage";
import LocationConfigPage from "layouts/SystemManagement/LocationConfigPage";
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import BulkUploadLogs from "layouts/BulkUploadLogs";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SupervisorIcon from './assets/cms-icons/supervisor.png'

import Card_mgmt from "layouts/Card_mgmt";
import AuditLogs from "layouts/AuditLogs";
import Supervisor from "layouts/Supervisor_mgmt";
import ResetSupervisorPassword from "layouts/Supervisor_mgmt/ResetSupervisorPassword";
import UpdateSupervisor from "layouts/Supervisor_mgmt/UpdateSupervisor";
import VendorPerformanceOverview from "layouts/Vendor_performance";
import VendorDashboard from "layouts/Vendor_performance";
import Faultdetection from "layouts/Faultdetection";

const userRole = getDecodedUserData()?.role;
const serviceID = getDecodedUserData()?.serviceID || [];

export const adminRoutes = [
  {
    type: "collapse",
    name: "Admins",
    key: "admins",
    icon: <Icon fontSize="small">account_circle</Icon>,
    route: "/admins",
    component: <Admin />,
  },
];
export const superAdminRoutes = [
  
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <HomeIcon />,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {

    key: "dashboard",
    route: "/",
    component: <Dashboard />,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("1"))) &&
  {
    type: "collapse",
    name: "Charger Management",
    key: "charger",
    icon: <PowerIcon />,
    route: "/charger",
    component: <ChargerMgmt />,
  },
  
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("9"))) &&
  {
    type: "collapse",
    name: "Driver Management",
    key: "Driver-Management",
    icon: (
      <img
        src={Driver_Mgmt_url}
        alt="Driver Management"
        style={{
          width: "1.25rem",
          height: "1.25rem",
          objectFit: "contain",
        }}
      />
    ),
    route: "/Driver-Management",
    component: <DriverMgmt/>,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("9"))) &&
  {
    key: "UpdateDriverPassword",
    icon: <ManageAccountsIcon />,
    route: "/Driver-Password",
    component: <UpdateDriverPassword/>,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("9"))) &&
  {
    key: "View Driver",
    icon: <ManageAccountsIcon />,
    route: "/Driver-Management/view-driver",
    component: <ViewDriver/>,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("9"))) &&
  {
    key: "UpdateDriver",
    icon: <ManageAccountsIcon />,
    route: "/Update-Driver",
    component: <UpdateDriver/>,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("9"))) &&
  {
    key: "UpdateDriver",
    icon: <ManageAccountsIcon />,
    route: "/Driver-Management/Assign-Driver",
    component: <AssignDriver/>,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("15"))) &&
  {
    type: "collapse",
    name: "Supervisor Management",
    key: "supervisor",
    icon: (
      <img
        src={SupervisorIcon}
        alt="Driver Management"
        style={{
          width: "1.25rem",
          height: "1.25rem",
          objectFit: "contain",
        }}
      />
    ),
    route: "/supervisor",
    component: <Supervisor/>,
  },
  {
    key: "Admins-Edit",
    route: "/supervisor/edit",
    component: <UpdateSupervisor/>,
  },
   {
    key: "Admins-Reset",
    route: "/supervisor/reset-password",
    component: <ResetSupervisorPassword/>,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("3"))) &&
  {
    key: "Location-View",
    route: "/location/view",
    component: <ViewLocation />,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("3"))) &&
  {
    key: "Location-View",
    route: "/location/view",
    component: <ViewLocation />,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("1"))) &&
  {
    key: "Charger-View",
    route: "/charger/view",
    component: <ViewCharger />,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("1"))) &&
  {
    key: "transaction-View",
    route: "/session",
    component: <ViewTransaction />,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("13"))) &&
  {
    type: "collapse",
    name: "Vehicle Management",
    key: "vehicle",
    icon: (
      <img
        src={Vehicle_mgmt_url}
        alt="Vehicle Mgmt"
        style={{
          width: "1.25rem",
          height: "1.25rem",
          objectFit: "contain",
        }}
      />
    ),
    route: "/vehicle",
    component: <VehicleMgmt/>,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("13"))) &&
  {
    key: "Vehicle-Edit",
    route: "/vehicle/edit",
    component: <UpdateVehicle/>,
  },

  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("3"))) &&
  {
    type: "collapse",
    name: "Location Management",
    key: "location",
    icon: <EditLocationAltIcon />,
    route: "/location",
    component: <LocationMgmt />,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("3"))) &&
  {

    key: "update-location",
    route: "/location/edit",
    component: <UpdateLocation />,
  },
  // (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("18"))) &&
  // {
  //   type: "collapse",
  //   name: "RFID Card",
  //   key: "rfidCard",
  //   icon: <CreditCardIcon/>,
  //   route: "/rfidCard",
  //   component: <Card_mgmt/>,
  // },
    (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("5"))) &&
  {
    type: "collapse",
    name: "Push Notifications",
    key: "push-notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/push-notifications",
    component: <Notifications />,
  },
  // (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("6"))) &&
  // {
  //   type: "collapse",
  //   name: "Customer Service",
  //   key: "customer-service",
  //   icon: <SupportAgentIcon />,
  //   route: "/customer-service",
  //   component: <CustomerService />,
  // },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("7"))) &&
  {
    type: "collapse",
    name: "Analytics & Reports",
    key: "reports",
    icon: <TextSnippetIcon />,
    route: "/reports",
    component: <Reports />,
  },
  
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("8"))) &&
  {
    type: "collapse",
    name: "Fault Management",
    key: "fault-management",
    icon: <SettingsApplicationsIcon/>,
    route: "/fault-management",
    component: <Faultdetection/>,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("8"))) &&
  {
    key: "notifications-page",
    route: "/notifications-list",
    component: <NotificationsPage/>,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("8"))) &&
  {
    key: "location-config",
    route: "/location-config",
    component: <LocationConfigPage/>,
  },
  
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("11"))) &&
  {
    type: "collapse",
    name: "Logs Management",
    key: "logs",
    icon: <ReportGmailerrorredIcon/>,
    route: "/logs",
    component: <Log/>,
  },

  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("12"))) &&
  {
    type: "collapse",
    name: "Reservation",
    key: "reservation",
    icon: <CalendarTodayIcon/>,
    route: "/reservation",
    component: <Reservation/>,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("14"))) &&
  {
    type: "collapse",
    name: "Bulk Upload Logs",
    key: "bulk-upload-logs",
    icon: <CloudUploadIcon/>,
    route: "/bulk-upload-logs",
    component: <BulkUploadLogs/>,
  },
  
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("17"))) &&
  {
    type: "collapse",
    name: "Audit Logs",
    key: "audit-logs",
    icon: <HistoryIcon />,
    route: "/audit-logs",
    component: <AuditLogs />,
  },
  (userRole === "Admin" || (userRole === "Manager" && serviceID.includes("16"))) &&
  {
    type: "collapse",
    name: "Vendor Performance",
    key: "vendor-performance",
    icon:  (
      <img
        src={VendorPerformanceUrl}
        alt="Vendor Performance"
        style={{
          width: "1.25rem",
          height: "1.25rem",
          objectFit: "contain",
        }}
      />
    ),
    route: "/vendor-performance",
    component: <VendorDashboard/>,
  },

  {
    key: "sign-in",
    route: "/sign-in",
    component: <SignIn />,
  },
  
  // {
  //   type: "collapse",
  //   name: "Sign Out",
  //   key: "sign-out",
  //   icon: <Icon fontSize="small">login</Icon>,
  //   route: "/sign-in",
  //   component: <SignIn />,
  // },


].filter(Boolean);

export const notLoggedInRoutes = [
  
  {
   
    key: "sign-in",
    route: "/sign-in",
    component: <SignIn />,
  },
];
